import * as R from 'ramda'

export function trimString(characters: number, name: string): string {
  if (name.length > characters) {
    return `${R.take(characters, name)}...`
  }

  return name
}
